<template>
  <div class="chip-container mr-2 mb-2">
    <v-chip
      :title="link"
      class="d-flex align-center"
      color="primary"
      link
      outlined
      small
      width="120"
    >
      <div v-if="isLoading" class="loader-container">
        <v-progress-circular
          color="primary"
          indeterminate
          size="10"
          width="1"
        />
      </div>

      <v-icon v-else color="primary" size="16">mdi-link</v-icon>

      <a
        class="caption text-truncate ml-2 no-text-decoration"
        target="_blank"
        rel="noopener noreferrer"
        :href="link"
        :title="link"
      >
        {{ title || link }}
      </a>
    </v-chip>
  </div>
</template>

<script>
const domParser = new DOMParser()

export default {
  name: 'LinkChip',

  props: {
    link: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      title: '',
      isLoading: false,
    }
  },

  mounted() {
    this.getTitle()
  },

  methods: {
    async getTitle() {
      try {
        this.isLoading = true
        const response = await fetch(this.link)
        const html = await response.text()
        const doc = domParser.parseFromString(html, 'text/html')
        this.title = doc.title
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chip-container {
  flex: 0;
  width: 200px;
}

.loader-container {
  width: 10px;
}
</style>
